module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAAAXNSR0IArs4c6QAAAM9JREFUKBWtkb0OAUEURtdPJCqJhk6iV3oIjeeQiNYTCYWORqeQ6DUSKqHxAhqRcL7hTsbYFYUvOTs/956d2WyS/Dk13neHC1R/eXeDpgP0YAg7qENmJJyhH3R8Fe2ECcIcSpG4Z90K9hITdCVlCqGYZz2DAbjEgjbVZGKB+RgW4JImWM3ENRsS/HW3LDrWFY2SdMIGvKDNG5wgjmoj0D9qwxVcVEhLKHRp8IKasyQ74UOQVNSDLOHoZs+xzDxVUE8OKtDU4hV9wwrermRFjQ8qsSeOYhkEcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_edit.png
// module id = 41
// module chunks = 0